import { Component } from '@verndale/core';
import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'is-in-viewport';

class CalloutBoatsFeatured extends Component {
  setupDefaults() {
    this.dom = {};
    Flickity.setJQuery($);
    jQueryBridget('flickity', Flickity, $);
    this.initSlider();
  }

  addListeners() {}

  initSlider() {
    const $boatsFeaturedCallouts = $('section.callout-boats-featured');
    if ($boatsFeaturedCallouts.length) {
      $boatsFeaturedCallouts.each(function () {
        const $sliderContainer = $(this);
          const $slider = $sliderContainer.find('.callout-boats-featured-list');
          const slidesWidth = $slider
            .find('.boat-card-item')
            .map(function () {
              return $(this).outerWidth();
            })
            .toArray()
            .reduce((a, b) => a + b, 0);
          let animated = false;

        function buildSlider() {
          const isDesktop = $(window).outerWidth() >= 1250;
            const options = {
              adaptiveHeight: false,
              imagesLoaded: true,
              setGallerySize: true,
              contain: true,
              wrapAround: true
            };

          if (!isDesktop) {
            options.cellAlign = 'left';
          }

          if ($slider.data('flickity')) {
            $slider.flickity('destroy');
          }

          if (slidesWidth > $sliderContainer.outerWidth()) {
            $slider.flickity(options);
          }
        }

        /* eslint-disable */
        function animateSlider() {
          if ($slider.isInViewport()) {
            if (!animated) {
              function fadeIn() {
                // sort by position.left so always from left to right
                let unfadedCards = $slider
                  .find('.boat-card-item.pre-fade')
                  .toArray()
                  .sort(function (a, b) {
                    return $(a).position().left - $(b).position().left;
                  });

                if (unfadedCards.length) {
                  $(unfadedCards[0]).removeClass('pre-fade');
                }

                if (unfadedCards.length && unfadedCards.length > 1) {
                  setTimeout(fadeIn, 250);
                } else {
                  animated = true;
                }
              }
              fadeIn();
            }
          }
        }

        $(window).resize(function () {
          buildSlider();
          animateSlider();
        });

        $(window).on('scroll', function () {
          animateSlider();
        });

        buildSlider();
        animateSlider();
      });
    }
  }
}

export default CalloutBoatsFeatured;
